import React from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { ChartContainer, SectionTitle } from '../styles'
import { chartPointsToData } from '../utils'

const BarSeriesChart = ({ title, points = [], height = '280px', color = '#427CAC' }) => {
    const data = chartPointsToData(points)

    if (!data.length) {
        return (
            <ChartContainer $height='120px'>
                {title && <SectionTitle>{title}</SectionTitle>}
                <div style={{ color: 'var(--text-tertiary)', fontSize: 14 }}>Sem dados no período.</div>
            </ChartContainer>
        )
    }

    return (
        <ChartContainer $height={height}>
            {title && <SectionTitle>{title}</SectionTitle>}
            <div style={{ flex: 1, minHeight: 0 }}>
                <ResponsiveContainer width='100%' height='100%'>
                    <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                        <CartesianGrid stroke='#f0f0f0' />
                        <XAxis dataKey='label' tick={{ fontSize: 11 }} />
                        <YAxis tick={{ fontSize: 11 }} />
                        <Tooltip />
                        <Bar dataKey='value' name='valor' fill={color} radius={[3, 3, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </ChartContainer>
    )
}

export default BarSeriesChart
